import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import Button from "../../../Button";
import QuestionTemplateForm from "../QuestionTemplateForm";
import {omit} from "lodash";


class CreateQuestionTemplate extends PureComponent {
  constructor(props) {
    super(props);

    this.questionTemplateFormRef = React.createRef();

    this.state = {
      modalOpen: false,
      saving: false,
    };

    this.onSaveStart = this.onSaveStart.bind(this);
    this.onSaved = this.onSaved.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.save = this.save.bind(this);
  }

  onSaveStart(){
    this.setState({
      saving: true
    });
  }

  onSaved(template){
    this.setState({
      modalOpen: false,
      saving: false,
    });

    this.props.onSaved(template);
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  save(){
    this.setState({
      saving: true
    });

    this.questionTemplateFormRef.current.save();
  }

  render() {
    const {modalOpen, saving} = this.state;

    return (
      <React.Fragment>
        <Button size={'sm'} onClick={this.toggleModal}><i className="fas fa-edit pointer mr-2" /> Utwórz szablon</Button>
        {modalOpen && <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
          <ModalHeader toggle={this.toggleModal}>Utwórz szablon pytania</ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <QuestionTemplateForm
              ref={this.questionTemplateFormRef}
              onSaveStart={this.onSaveStart}
              onSaved={this.onSaved}
              questionId={this.props.questionTemplate.id}
              template={omit(this.props.questionTemplate, ['id'])}
            />
          </ModalBody>
          <ModalFooter>
            <FormattedMessage id="_.button.cancel">{
              (message) =>
                <Button color="secondary" className="mb-0" onClick={this.toggleModal}>{message}</Button>
            }</FormattedMessage>
            <FormattedMessage id="_.button.save">{
              (message) => <Button
                color="primary"
                loading={saving}
                onClick={this.save}
              >{message}</Button>
            }</FormattedMessage>
          </ModalFooter>
        </Modal>}
      </React.Fragment>
    );
  }
}

CreateQuestionTemplate.propTypes = {
  onSaved: PropTypes.func.isRequired,
  questionTemplate: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default CreateQuestionTemplate;